interface RefreshTokenAttempt {
  timestamp: number;
  error: string;
}

const REFRESH_TOKEN_ATTEMPTS_KEY = 'refreshTokenAttempts';
const MAX_REFRESH_TOKEN_ATTEMPTS = 3;
const ATTEMPT_WINDOW_MS_ONE_HOUR = 60 * 60 * 1000;

const addRefreshTokenAttempt = (error: string): void => {
  const attempts = getRefreshTokenAttempts();
  const now = Date.now();

  const validAttempts = attempts.filter(
    (attempt) => now - attempt.timestamp < ATTEMPT_WINDOW_MS_ONE_HOUR,
  );

  validAttempts.push({ timestamp: now, error });
  localStorage.setItem(
    REFRESH_TOKEN_ATTEMPTS_KEY,
    JSON.stringify(validAttempts),
  );
};

const hasExceededRefreshTokenAttempts = (): boolean => {
  const attempts = getRefreshTokenAttempts();
  const now = Date.now();

  const validAttempts = attempts.filter(
    (attempt) => now - attempt.timestamp < ATTEMPT_WINDOW_MS_ONE_HOUR,
  );

  return validAttempts.length >= MAX_REFRESH_TOKEN_ATTEMPTS;
};

const getRefreshTokenAttempts = (): RefreshTokenAttempt[] => {
  const attemptsJson = localStorage.getItem(REFRESH_TOKEN_ATTEMPTS_KEY);
  return attemptsJson ? JSON.parse(attemptsJson) : [];
};

const clearRefreshTokenAttempts = () => {
  localStorage.removeItem(REFRESH_TOKEN_ATTEMPTS_KEY);
};

export {
  addRefreshTokenAttempt,
  hasExceededRefreshTokenAttempts,
  getRefreshTokenAttempts,
  clearRefreshTokenAttempts,
};
